import { Select } from "@chakra-ui/react";
import React from "react";

const VatDropDown = ({ value, onChange }) => {
  const vatOptions = [21, 19, 11, 9, 5, 0];
  const selectedValue = value ?? 0; // Default to 0 if value is undefined or null

  const handleChange = (event) => {
    const newValue = parseInt(event.target.value, 10);
    onChange(newValue);
  };

  return (
      <Select
          bg="white"
          size="sm"
          borderRadius="lg"
          value={selectedValue}
          onChange={handleChange}
          placeholder="Selectează o cotă"
          border='1px' 
          borderColor='black'
      >
        {vatOptions.map((vat) => (
            <option key={vat} value={vat}>
              {vat}%
            </option>
        ))}
      </Select>
  );
};

export default VatDropDown;
